import { styled } from 'stitches.config'
import { Text } from 'components/Text'
import { Button } from 'components/Button'
import { Proteins } from 'models/Pet'

export const recipeColorVariant = {
  recipe: {
    default: {
      background: '$tertiary-100',
      '&:hover, &:focus': {
        background: '$tertiary-100',
      },
    },
    [Proteins.CHICKEN]: {
      background: '$quaternary-220',
      '&:hover, &:focus': {
        background: '$quaternary-220',
      },
    },
    [Proteins.BEEF]: {
      background: '$quaternary-110',
      '&:hover, &:focus': {
        background: '$quaternary-110',
      },
    },
    [Proteins.DUCK]: {
      background: '$quaternary-320',
      '&:hover, &:focus': {
        background: '$quaternary-320',
      },
    },
    [Proteins.TURKEY]: {
      background: '$quaternary-410',
      '&:hover, &:focus': {
        background: '$quaternary-410',
      },
    },
    [Proteins.LAMB]: {
      background: '$quaternary-520',
      '&:hover, &:focus': {
        background: '$quaternary-520',
      },
    },
    [Proteins.VENISON]: {
      background: '$quaternary-620',
      '&:hover, &:focus': {
        background: '$quaternary-620',
      },
    },
  }
}

export const RequirementText = styled('div', {
  color: '$accent-black',
  fontSize: '$body',
  textAlign: 'center',
  width: '100%',
  padding: '$2',
  maxWidth: '800px',
  marginTop: '$6',
  marginBottom: '$2',

  '@bp3': {
    margin: 'auto',
    fontSize: '$bodyLarge'
  },

  variants: {
    ...recipeColorVariant,
  }
})

export const Span = styled('span', {
  fontWeight: '$semiBold',
})

export const InfoWrapper = styled('div', {
  width: '100%',
  '& > div': {
    marginTop: 0,
  },
})

export const DesktopHeroWrapper = styled('div', {
  display: 'none',

  width: '50%',
  '& > div': {
    width: '100%',
  },

  '@bp3': {
    display: 'block',
  },
})

export const PricePerUnit = styled(Text, {
  textAlign: 'center',
  marginTop: '$3',
  marginBottom: '$2',
  '@bp3': {
    margin: 'auto',
  },
})

export const Spacer = styled('div', {
  height: '30px',
})

export const CtaButtonDisabled = styled(Button, {
  color: '$accent-white',
  cursor: 'not-allowed',
})